export default "__VITE_ASSET__DFmsxVF8__"